export default __webpack_public_path__ + "static/media/org-program-submissions.60d04ebe.png";